import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Hook to handle domain-based routing:
 * - lapyno.com / www.lapyno.com → Marketing site (Landing page on /)
 * - app.lapyno.com / staging.app.lapyno.com → Application (redirect / to /app)
 */
export function useDomainRedirect() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const hostname = window.location.hostname;
    
    // Check if we're on the app subdomain
    const isAppDomain = 
      hostname === 'app.lapyno.com' || 
      hostname === 'staging.app.lapyno.com' ||
      hostname.startsWith('app.') ||
      hostname.startsWith('staging.');
    
    // If on app domain and at root, redirect to /app
    if (isAppDomain && location.pathname === '/') {
      navigate('/app', { replace: true });
    }
  }, [navigate, location.pathname]);
}

/**
 * Check if current domain is an app domain (not marketing)
 */
export function isAppDomain(): boolean {
  const hostname = window.location.hostname;
  return (
    hostname === 'app.lapyno.com' || 
    hostname === 'staging.app.lapyno.com' ||
    hostname.startsWith('app.') ||
    hostname.startsWith('staging.') ||
    hostname === 'localhost' ||
    hostname.includes('lovable')
  );
}
